module.exports = __webpack_public_path__ + "static/img/01.30eadc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat/01.png
// module id = LDDy
// module chunks = 0